/** "Get certified" (ux-bug-pass-7 ticket 17). The cards arrive in `GET /v1/insights` (`certifications`); this sets an
 *  account's step on one catalogue certification. It sets a value, so a repeat is safe. 404 for an id not in the
 *  catalogue, 422 for any other step. */
import { api } from './client';
import type { CertificationStep, CertificationStepValue } from './types';

export const certificationsApi = {
  setStep: (id: string, step: CertificationStepValue) => api<CertificationStep>(`/v1/certifications/${encodeURIComponent(id)}`, { method: 'PUT', body: { step } }),
};
